import React, { forwardRef, useState, useEffect, useRef } from 'react';
import axios from 'axios';

import { MagnifyingGlass, Warning } from '../../../icons';
import Loading from '../../../common_components/Loading';
import { SearchableTable } from '../../../common_components/SearchableTable';
import { cn } from '../../../utils';

export function DataPreviewer({ file, filterParams }) {
  const previewModalRef = useRef();

  return (
    <>
      <PreviewDialog
        file={file}
        filterParams={filterParams}
        ref={previewModalRef}
      />
      <button
        className="btn btn-info btn-sm ml-2"
        onClick={() => previewModalRef?.current?.showModal()}
        title="Podgląd przefiltrowanych danych"
      >
        Podgląd
        <MagnifyingGlass className={'size-4'} />
      </button>
    </>
  );
}

const PreviewDialog = forwardRef(function PreviewDialog(
  { filterParams, file },
  ref,
) {
  const [tableData, setTableData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    // not sure if this if(file) isn't a hacky solution
    // . there was some problem when changing a file
    if (file) {
      axios
        .get(window.DjUrls['ate:file_view'](), { params: filterParams })
        .then((res) => {
          setTableData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
        });
    }
  }, [filterParams, file]);

  return (
    <dialog ref={ref} className="modal">
      <div
        className={cn('modal-box prose', error === null && 'max-w-screen-xl')}
      >
        {error ? (
          <>
            <h2 className="flex items-center">
              <Warning className="w-12 h-12 mr-4" />
              Wystąpił nieoczekiwany błąd
            </h2>
            <p className="text-lg">
              Nie możemy wyświetlić danych. Spróbuj ponownie później, lub wgraj
              inny zestaw danych.
            </p>
          </>
        ) : (
          <>
            <div className="flex items-end mb-8 justify-between">
              <h1 className="mb-0">Dane będące przedmiotem analizy&nbsp;</h1>
              {tableData && (
                <h2
                  className="mt-0 mb-0 font-normal"
                  title="ilość rzędów z danymi"
                >
                  (łącznie {tableData?.length})
                </h2>
              )}
            </div>
            <div>
              {!isLoading && tableData ? (
                <SearchableTable
                  caption={
                    'Dane użyte do wizualizacji w następnych zakładkach:'
                  }
                  data={tableData}
                  tableSize={'table-lg'}
                  tableFixed={true}
                  className={'table-pin-rows'}
                  wrapperClassName="max-h-[min(500px,90vh)]"
                  ariaLabel="Tabela podglądu danych z przewijaniem"
                />
              ) : (
                <Loading />
              )}
            </div>
          </>
        )}
        <div className="modal-action">
          <form method="dialog">
            <button className="btn btn-secondary">Zamknij</button>
          </form>
        </div>
      </div>
    </dialog>
  );
});
